<template>
  <div class="header">
    <div class="game-details">
      <h2>
        <router-link
          v-if="leagueRoute"
          :to="leagueRoute"
          class="league-link"
        >
          {{ formattedLeague }}
        </router-link>
        <template v-else>{{ formattedLeague }}</template>
      </h2>
      <p class="fixture-date">{{ formattedDate }}</p>
    </div>
    <br>
    <div class="team-info">
      <div class="team-logo-container">
        <TeamLogoBadge :src="gameDetails.first_team_logo" :team-name="gameDetails.first_team" :size="96" />
        <p class="team-name">{{ gameDetails.first_team }}</p>
      </div>
      <div class="vs">vs</div>
      <div class="team-logo-container">
        <TeamLogoBadge :src="gameDetails.second_team_logo" :team-name="gameDetails.second_team" :size="96" />
        <p class="team-name">{{ gameDetails.second_team }}</p>
      </div>
    </div>
  </div>
</template>

  
  <script>
  import { format, parseISO } from 'date-fns';
  import TeamLogoBadge from './TeamLogoBadge.vue';
  import { formatLeagueName } from '../utils/formatLeagueName';
  
  export default {
    components: {
      TeamLogoBadge
    },
    props: {
      gameDetails: {
        type: Object,
        required: true
      }
    },
    computed: {
      formattedLeague() {
        return formatLeagueName(this.gameDetails?.league);
      },
      leagueRoute() {
        return this.gameDetails?.league_slug ? `/football/league/${this.gameDetails.league_slug}` : '';
      },
      formattedDate() {
        return this.gameDetails ? format(parseISO(this.gameDetails.date), 'eeee, MMMM do, yyyy') : '';
      }
    }
  };
  </script>
  
  <style scoped>
  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .game-details {
    text-align: center;
  }
  
  .team-info {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  
  .team-logo-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex:1;  /* Ensures even distribution of space */
  }
  
  .team-name {
    font-size:medium;
    font-weight: bold;
    margin-top: 8px;
    white-space: normal;
    overflow-wrap: break-word;
    text-align: center;
    color: #495057;
  }
  
  .vs {
    font-size: medium;
    font-weight: bold;
    margin: 0 20px;
    align-self: center;
    color: #495057;
  }
  
  h2,
  .fixture-date {
    margin: 5px 0;
    color: #495057;
  }

  .fixture-date {
    font-size: 1rem;
  }

  .league-link {
    color: inherit;
    text-decoration: none;
    border-bottom: 1px solid transparent;
    transition: border-color 0.2s ease, color 0.2s ease;
  }

  .league-link:hover {
    color: #173252;
    border-color: #173252;
  }

  @media (max-width: 700px) {
    .team-info {
      gap: 8px;
    }

    .team-logo-container {
      min-width: 0;
    }

    .team-name {
      font-size: 0.9rem;
    }

    .vs {
      margin: 0 8px;
      font-size: 0.9rem;
    }

    h2 {
      font-size: 1rem;
    }

    .fixture-date {
      font-size: 0.9rem;
    }

  }
  </style>
  
